<style scoped>
  .layout-header {
    background-color: #0e90d2;
    height: 49px;

  }

  .layout-logo {
    width: 24px;
    height: 24px;
    /*border-radius: 3px; */
    float: left;
    position: relative;
    top: 10px;
    left: 10px;
    vertical-align: middle;
    display: inline-block;
    z-index: 9996;
  }

  .layout-menu {
    background-color: #0e90d2;
    height: 49px;
    line-height: 49px;
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    border-color: #0e90d2;
    z-index: 9996;
  }

  .layout-title {
    position: relative;
    text-align: center;
    color: white;
    /*!position: absolute;*/
    top: 0px;
    height: 50px;
    line-height: 50px;
    width: 120px;
    z-index: 9997;
  }

  .center-text {
    display: inline-block;
    width: 90px
  }

  .layout-nav {
    /*!margin: 0 auto;*/
    margin-right: 5px;
    position: relative;
    height: 100%;
    float: right;
  }
</style>
<template>
 <!-- <Header class="layout-header"> -->

      <Menu mode="horizontal" class="layout-menu" active-name="3" @on-select="turnUrl">
        <a href="#" style=" z-index: 9998;">
          <Icon type="ios-home-outline" class="layout-logo" color="white" size="24" /> </a>

    <div class="layout-nav">
      <Submenu name="3">
        <template slot="title">
          <Icon type="ios-apps" color="white" size="24" />
          菜单
        </template>
        <MenuGroup title="宝能公务">
          <MenuItem name="3-1" @click='window.location = "http://www.baonengjet.com/topics/category/flight_charter/"'>我要包机</MenuItem>
          <MenuItem name="3-2" @click='window.location = "http://www.baonengjet.com/topics/category/vip/"'> 会员尊享</MenuItem>
          <MenuItem name="3-3" @click='window.location = "http://www.baonengjet.com/topics/category/jet_agent/"'>飞机托管</MenuItem>
          <MenuItem name="3-4" @click='window.location = "http://www.baonengjet.com/topics/category/trusteeship/"'>关于我们</MenuItem>
          <MenuItem name="3-5" @click='window.location = "http://www.baonengjet.com/contact2/"' >联系我们</MenuItem>
        </MenuGroup>
      </Submenu>
    </div>
    </Menu>
    <!--<div class="layout-title">
      <h4 class="center-text"> 宝能公务航空</h4>
    </div> -->

  <!--</Header> -->

</template>

<script>
/* eslint-disable */
export default {
  name: 'BnjHeaderMobile',
  data () {
    return {
      msg: ''
    }
  },
  methods: {
    turnUrl (name) {
      if (name === '3-1') {
        window.location = 'http://www.baonengjet.com/topics/category/flight_charter/'
      } else if (name === '3-2') {
        window.location = 'http://www.baonengjet.com/topics/category/vip/'
      } else if (name === '3-3') {
        window.location = 'http://www.baonengjet.com/topics/category/jet_agent/'
      } else if (name === '3-4') {
        window.location = 'http://www.baonengjet.com/topics/category/trusteeship/'
      } else if (name === '3-5') {
        window.location = 'http://www.baonengjet.com/contact2/'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/bnj-header-mobile.vue